import {TYPES_HEURES,TYPES_PRIMES,TYPES_INDEMNITES} from '../config/apiEndpoints';
import {normalizeSearch} from './listSearch';
function complete(labels,actual=[]) {
 const map=new Map();
 for(const row of actual){if(row?.label)map.set(normalizeSearch(row.label),row);}
 for(const label of labels){const key=normalizeSearch(label);if(!map.has(key))map.set(key,{value:`manual:${key}`,label,montant:null,montantNonAssujetti:null,taux:null,idPrime:''});}
 return [...map.values()].sort((a,b)=>a.label.localeCompare(b.label,'fr'));
}
export function timesheetCatalogs(primes=[],hours=[]) {
 const indemnities=primes.filter(row=>row.montantNonAssujetti!=null||normalizeSearch(row.label||'').startsWith('indemnite'));
 return {primes:complete(TYPES_PRIMES,primes),hours:complete(TYPES_HEURES,hours),indemnities:complete(TYPES_INDEMNITES,indemnities)};
}
